<template>
  <div class="m-4">
    <p>Uitloggen...</p>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
export default {
  mounted () {
    this.logout()
  },
  methods: {
    logout () {
      const app = this
      this.$request.post('/authentication/logout')
      .then((response) => {
        if (
            response.data
            &&
            response.data.success
            &&
            response.data.success === true
        ) {
          // Logged out
        } else {
          Sentry.captureException('API logout request failed');
        }
        app.$store.commit('SET_SESSION', null)
        this.resetState(() => {
            if (app.isGastouderapp()) {
                window.location.href = process.env.VUE_APP_BASE_LOGIN + '/authentication/kidsadmin-sso/gastouderapp'
            } else {
                window.location.href = process.env.VUE_APP_BASE_LOGIN + '/authentication/kidsadmin-sso/groepsapp'
            }
        })
      })
    }
  }
}
</script>
